import { z } from 'zod';

export const viewName = z.enum([
  'dashboard',
  'projects',
  'library',
  'tracker',
  'builder',
  'wizard',
  'just_knit',
  'ai_import',
  'settings',
]);
export type ViewName = z.infer<typeof viewName>;

export const patternShape = z.object({
  segment_count: z.number().int().nonnegative(),
  step_count: z.number().int().nonnegative(),
  has_groups: z.boolean(),
  has_counters: z.boolean(),
  has_flex_groups: z.boolean(),
  max_depth: z.number().int().nonnegative(),
}).strict();
export type PatternShape = z.infer<typeof patternShape>;
